module.exports = __webpack_public_path__ + "img/facebook.3ae356be.png";